module.exports = __webpack_public_path__ + "static/media/udit.4965457b.jpg";